// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DirectMessageBaseClass as DirectMessageBase } from '../DirectMessageBase';

export class DirectAlgorithmMessageBase extends DirectMessageBase {
    AlgorithmId: number = -1;
    AlgorithmName: string;
}
